import { getThemeSpacers } from "commons/utils";
import styled from "styled-components";
import { viewPortBpPx } from "features/common";

const spacerXS = getThemeSpacers("xs");
const spacerS = getThemeSpacers("s");
const spacerXL3 = getThemeSpacers("xl3");

export const BankTransferDetails = styled.dl`
  margin: ${spacerXL3} 0 0;
  display: grid;
  grid-template-columns: minmax(130px, max-content) 1fr;
  gap: ${spacerS} ${spacerXL3};

  dt,
  dd {
    margin: 0;
  }

  @media (max-width: ${viewPortBpPx.s}) {
    grid-template-columns: 1fr;
    dd {
      margin-bottom: ${spacerXS};
    }
  }
`;
